module.exports = __webpack_public_path__ + "static/media/beaverton@2x.0b4ff92f.webp";